// src/theme/tokens/typography.js
// Faz 1 · Genisletilmis tipografi sistemi.
// Mevcut theme/typography.js korunur. Bu dosya:
//   1. Yeni font family'leri (Newsreader serif · uzun-form okuma) ekler
//   2. "Display" scale ekler (mevcut xs-6xl korunur)
//   3. Letter-spacing semantik token'larini saglar
//   4. Font-feature presetleri (tnum, frac, smcp) tanimlar
//   5. Semantic typography token'lari (typography.body.text, vb.) saglar
// Faz 2'de Text/Heading component variantlari bunlari kullanir.

// ===== FONT FAMILIES (mevcut typography.js'e EK) =====
// Inter ve Roboto Mono mevcut · dokunulmaz.
// Newsreader: uzun-form okuma icin serif (LectureViewPage).
// JetBrains Mono: kod ve sayisal duzen icin alternatif (gelecek).
const fontsExtension = {
  reading: `"Newsreader", "Charter", "Iowan Old Style", "Apple Garamond", Georgia, "Times New Roman", serif`,
  numeric: `"Inter", "SF Pro Display", -apple-system, BlinkMacSystemFont, sans-serif`, // tnum/lnum ile
  display: `"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif`,        // baslik vurgusu
};

// ===== DISPLAY SCALE (xs-6xl mevcut, ek olarak large display) =====
const fontSizesExtension = {
  // Display · landing hero, 404, marketing
  'display.sm': '1.875rem',  // 30px
  'display.md': '2.25rem',   // 36px
  'display.lg': '3rem',      // 48px
  'display.xl': '3.75rem',   // 60px
  'display.2xl': '4.5rem',   // 72px
  // Mikrokopya
  'micro': '0.625rem',       // 10px (legal, copyright)
};

// ===== LETTER SPACING (mevcut tighter-widest korunur, semantik adlar eklenir) =====
const letterSpacingsExtension = {
  // Semantik
  display: '-0.04em',     // Buyuk display tipo (Apple/Stripe tarzi)
  heading: '-0.02em',     // H1-H3
  subheading: '-0.01em',  // H4-H6
  body: '0',
  caption: '0.01em',
  micro: '0.025em',       // 11-12px small caps
  uppercase: '0.05em',    // ALL CAPS metinler
  uppercaseWide: '0.08em',
};

// ===== LINE HEIGHTS (mevcut korunur, semantik adlar eklenir) =====
const lineHeightsExtension = {
  // Semantik (mevcut adlandirmaya alias)
  display: 1.05,
  heading: 1.15,
  subheading: 1.25,
  body: 1.55,             // Mevcut 'tall' (1.65) yerine biraz daha kompakt body
  reading: 1.7,           // Uzun-form okuma
  ui: 1.4,                // Buton, label, kompakt UI
};

// ===== FONT WEIGHTS (mevcut korunur) =====
// Yeni: variable font axes icin orta degerler (Inter Variable destegi).
const fontWeightsExtension = {
  // Variable font ara degerler
  450: 450,
  550: 550,
  650: 650,
};

// ===== FONT FEATURE SETTINGS (OpenType) =====
const fontFeatures = {
  // Sayisal · tablo hizalama (dashboard stats)
  numeric: '"tnum", "lnum"',
  numericOldStyle: '"onum", "lnum"',
  // Kesir · 1/2 -> guzel kesir
  fractions: '"frac"',
  // Small caps · etiket
  smallCaps: '"smcp", "c2sc"',
  // Stylistic alternatives · Inter'in alternatif glyph'leri
  alternative: '"ss01"',
  // Liga + kontekstual
  default: '"liga", "calt", "kern"',
};

// ===== SEMANTIK TIPOGRAFI TOKEN'LARI (Faz 2'de Text variant'larina baglanir) =====
// 'typographySemantics' objesi kaldirildi (sifir importer · Faz 2 wiring tamamlanmadi).
// fontsExtension/fontSizesExtension/letterSpacingsExtension/lineHeightsExtension/
// fontWeightsExtension/fontFeatures aktif kullanimda kaliyor.
const typographySemantics = {};

export default typographySemantics;
export {
  fontsExtension,
  fontSizesExtension,
  letterSpacingsExtension,
  lineHeightsExtension,
  fontWeightsExtension,
  fontFeatures,
};
